import React, { Component } from 'react'
import PropTypes from 'prop-types';
import queryString from 'query-string'
import Error from './Error'
import autoBind from "react-autobind";

class ErrorContainer extends Component {

  constructor(props) {
    super(props)
    autoBind(this);
    const params = queryString.parse(props.location.search)
    const err = props.location.state.error 

    const message = err.userErrorMessage ? err.userErrorMessage: (err.response ? err.response.data.message : err);

    this.state = {
      message: message,
      sessionId: params.sessionId
    }
  }

  render() {
    const { message } = this.state
    return (
      <div>
        <Error message={message} />
      </div>
    )
  }
}

ErrorContainer.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    state: PropTypes.object.isRequired,
  })
};

export default ErrorContainer



// WEBPACK FOOTER //
// ./src/components/error/ErrorContainer.js